// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3YNkK","gfeWrapper":"CalendarEvent_gfeWrapper__2cuLh"};